"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const DefaultIcon_1 = __importDefault(require("./icons/DefaultIcon"));
const IconType_1 = __importDefault(require("./enums/IconType"));
const ColorType_1 = __importDefault(require("./enums/ColorType"));
const LegalCheckBox = (props) => {
    return (react_1.default.createElement("div", { className: "legalcheckbox" },
        react_1.default.createElement("input", { value: String(props.value), className: "legalcheckbox__input", name: props.name, id: props.name, type: "checkbox" }),
        react_1.default.createElement("div", { onClick: () => props.onChangeHandler(!props.value), tabIndex: 0, className: props.value === true
                ? "legalcheckbox__box legalcheckbox__box--checked"
                : "legalcheckbox__box legalcheckbox__box--unchecked" },
            react_1.default.createElement(DefaultIcon_1.default, { type: IconType_1.default.Check, color: ColorType_1.default.White, size: "16" })),
        props.type !== "privacy" ? (react_1.default.createElement("label", { className: "legalcheckbox__label", htmlFor: props.name },
            "I have read and accept the",
            " ",
            react_1.default.createElement("a", { href: props.hyperlink, rel: "noreferrer", target: "_blank", className: "legalcheckbox__link" }, "Terms of Service"),
            ".")) : (react_1.default.createElement("label", { className: "legalcheckbox__label", htmlFor: props.name },
            "I have read and accept the",
            " ",
            react_1.default.createElement("a", { href: props.hyperlink, target: "_blank", rel: "noreferrer", className: "legalcheckbox__link" }, "Privacy Policy"),
            "."))));
};
exports.default = LegalCheckBox;
